import { useEffect, useRef } from 'react';
import { useAdminData } from '../contexts/AdminDataContext';

declare global {
  interface Window {
    tarteaucitron: any;
  }
}

const TrackingTags: React.FC = () => {
  const { trackingConfig, remoteLoaded } = useAdminData();
  const initialized = useRef(false);
  const configRef = useRef(trackingConfig);
  configRef.current = trackingConfig;

  useEffect(() => {
    if (!remoteLoaded) return;
    if (initialized.current) return;

    let timer: ReturnType<typeof setInterval> | null = null;

    const initTAC = () => {
      const tac = window.tarteaucitron;
      if (!tac) return;

      initialized.current = true;
      const config = configRef.current;

      const serviceDefaultState: boolean | 'wait' =
        config.serviceDefaultState === 'true' ? true
        : config.serviceDefaultState === 'false' ? false
        : 'wait';

      const tacOptions: Record<string, unknown> = {
        privacyUrl: config.privacyUrl,
        bodyPosition: config.bodyPosition,
        hashtag: config.hashtag,
        cookieName: config.cookieName,
        orientation: config.orientation,
        groupServices: config.groupServices,
        showDetailsOnClick: config.showDetailsOnClick,
        serviceDefaultState,
        showAlertSmall: config.showAlertSmall,
        showTitleBanner: config.showTitleBanner,
        cookieslist: config.cookieslist,
        cookieslistEmbed: config.cookieslistEmbed,
        closePopup: config.closePopup,
        showIcon: config.showIcon,
        iconPosition: config.iconPosition,
        adblocker: config.adblocker,
        DenyAllCta: config.denyAllCta,
        AcceptAllCta: config.acceptAllCta,
        highPrivacy: config.highPrivacy,
        alwaysNeedConsent: config.alwaysNeedConsent,
        handleBrowserDNTRequest: config.handleBrowserDNTRequest,
        removeCredit: config.removeCredit,
        moreInfoLink: config.moreInfoLink,
        useExternalCss: config.useExternalCss,
        useExternalJs: config.useExternalJs,
        readmoreLink: config.readmoreLink,
        mandatory: config.mandatory,
        mandatoryCta: config.mandatoryCta,
        googleConsentMode: config.googleConsentMode,
        bingConsentMode: config.bingConsentMode,
        pianoConsentMode: config.pianoConsentMode,
        pianoConsentModeEssential: config.pianoConsentModeEssential,
        softConsentMode: config.softConsentMode,
        dataLayer: config.dataLayer,
        serverSide: config.serverSide,
        partnersList: config.partnersList,
        locale: 'fr',
      };
      if (config.iconSrc) tacOptions.iconSrc = config.iconSrc;
      if (config.cookieDomain) tacOptions.cookieDomain = config.cookieDomain;
      if (config.customCloserId) tacOptions.customCloserId = config.customCloserId;

      tac.init(tacOptions);

      if (config.googleTagId) {
        if (config.googleTagId.startsWith('GTM-')) {
          tac.user.googletagmanagerId = config.googleTagId;
          (tac.job = tac.job || []).push('googletagmanager');
        } else {
          tac.user.gtagUa = config.googleTagId;
          (tac.job = tac.job || []).push('gtag');
        }
      }

      if (config.matomoSiteId) {
        tac.user.matomoId = parseInt(config.matomoSiteId, 10);
        (tac.job = tac.job || []).push('matomo');
        if (config.matomoUrl) {
          tac.user.matomoHost = config.matomoUrl.endsWith('/') ? config.matomoUrl : `${config.matomoUrl}/`;
        }
      }

      if (config.matomoTagManagerUrl) {
        tac.user.matomotmUrl = config.matomoTagManagerUrl;
        (tac.job = tac.job || []).push('matomotm');
      }
    };

    if (window.tarteaucitron) {
      initTAC();
    } else {
      timer = setInterval(() => {
        if (window.tarteaucitron) {
          clearInterval(timer!);
          timer = null;
          initTAC();
        }
      }, 100);
      setTimeout(() => { if (timer) clearInterval(timer); }, 5000);
    }

    return () => { if (timer) clearInterval(timer); };
  }, [remoteLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default TrackingTags;
